<app-summary-field labelWithValue [label]="label" [value]="value" *ngIf="shouldDisplay" [iconName]="iconName" >
    <ng-content></ng-content>
</app-summary-field>

